import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatDialogueUpdatedEvent} from '../types/events'
import {NinchatState} from 'api/types'
import {extractProperties} from './'

export const dialogueUpdated: CaseReducer<NinchatState> = (state, action) => {
    const {
        user_id,
        ...properties
    } = extractProperties<NinchatDialogueUpdatedEvent>(action.payload)

    return {
        ...state,
        user_dialogues: {
            ...state.user_dialogues,
            [user_id]: {
                ...state.user_dialogues[user_id],
                ...properties,
            },
        },
    }
}
